import { inject } from 'mobx-react';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { RouteProps } from 'react-router';
import Button, { ButtonType } from '../../components/button/button';
import Image, { ImageType } from '../../components/image/image';
import { ROUTE_SPORTS_UNIVERSE, ROUTE_TESTERS } from '../../RouteList';
import messages from './messages';
import classNames from 'classnames';

@inject('routing', 'dataStore')
export default class LaunchingRocket extends React.Component<
  RouteProps & any,
  any
> {
  public state = {
    extraClasses: ''
  };

  private animationFinished() {
    const {
      routing: { push }
    } = this.props;
    this.props.dataStore.isSportVlaanderen &&
    !this.props.dataStore.isStandAloneVersion
      ? push(ROUTE_TESTERS)
      : push(ROUTE_SPORTS_UNIVERSE);
  }

  private launchTheRocket() {
    this.setState({ extraClasses: 'is-launching' });
    setTimeout(() => this.animationFinished(), 2000);
  }

  public render() {
    return (
      <React.Fragment>
        <Image
          type={ImageType.launchingKleermaker}
          imgSrc="/images/svg/launching-kleermaker-no-button.svg"
          alt={'Launch Rocket'}
        >
          <p
            className={classNames(
              'c-image__label-rocket c-image__label-rocket-in-image'
            )}
          >
            <FormattedMessage {...messages.launchRocket} />
          </p>
        </Image>
        <Image
          type={ImageType.launchingRocket}
          imgSrc="/images/gif/launching-rocket.gif"
          alt={'Launch Rocket'}
          extraClasses={this.state.extraClasses}
        />
        <Button
          type={ButtonType.circleIconRocket}
          onClick={() => this.launchTheRocket()}
        />
        <Image
          type={ImageType.launchingSmoke}
          imgSrc="/images/gif/launching-smoke.gif"
          alt={'Launch Rocket'}
          extraClasses={this.state.extraClasses}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/launching-rocket/LaunchingRocket.tsx